// extracted by mini-css-extract-plugin
export var header = "PLPBanner-module--header--4ecb6";
export var root = "PLPBanner-module--root--fb37d";